import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Documentação</Title>

                    <section className="mt-2 p-3">

                        <p>
                            Axial, sagital e coronal utilizar ww 260 e wl 45;
                        </p>
                        <p>
                            <b>Axial P.M. S/C -</b> 2 filmes na formatação de 20 imagens;<br/>
                            <b>Axial P.M. C/C -</b> 2 filmes na formatação de 20 imagens;<br/>
                            <b>Sagital P.M. C/C -</b> 1 filme na formatação de 20 imagens;<br/>
                            <b>Coronal P.M. C/C -</b> 1 filme na formatação de 20 imagens;<br/>
                        </p>

                        <p>Sempre que utilizar o meio de contraste I.V. identificar no filme.</p>

                        <p>
                            <b>Impressão Mista, Filme e Papel</b><br/>
                            Axial em filme; <br/>
                            Sagital em papel;<br/>
                            Coronal em papel;<br/>
                        </p>
                        <p>
                            <b>Impressão apenas em Papel</b><br/>
                            Axial em papel;<br/>
                            Sagital em papel;<br/>
                            Coronal em papel;<br/>
                        </p>
                    </section>
                </div>
            </div>
        </Container>
    )
}